import React, { ComponentProps, FunctionComponent } from "react";

const ContactsBookIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 14",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,

    /*#__PURE__*/ React.createElement("path", {
      d: "M8.30392 6.50195H8.33392C9.42705 6.50195 10.3176 5.62506 10.3339 4.53201C10.3421 4.00139 10.1389 3.48951 9.76956 3.10889C9.40018 2.72826 8.89455 2.51013 8.36392 2.502H8.33392C7.8033 2.49825 7.29329 2.70512 6.91516 3.07701C6.53766 3.44951 6.32266 3.9564 6.3189 4.48702C6.31078 5.5914 7.19958 6.49379 8.30392 6.50195ZM8.33392 3.50193C8.73829 3.50193 9.1033 3.74567 9.25767 4.11944C9.41267 4.49318 9.32705 4.92319 9.04079 5.20882C8.75516 5.49508 8.32515 5.58069 7.95141 5.4257C7.57766 5.27132 7.3339 4.90632 7.3339 4.50195C7.3339 3.94945 7.78142 3.50193 8.33392 3.50193Z",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("path", {
      d: "M8.59407 7.00016H8.09407C7.09906 6.99641 6.1435 7.38829 5.43773 8.09017C4.73274 8.79142 4.33523 9.74522 4.33398 10.7401V11.5001C4.33398 11.6326 4.38648 11.7601 4.48023 11.8539C4.57399 11.9476 4.70148 12.0001 4.83398 12.0001H11.834C11.9665 12.0001 12.094 11.9476 12.1878 11.8539C12.2815 11.7601 12.334 11.6326 12.334 11.5001V10.7401C12.3328 9.74885 11.9384 8.79817 11.2371 8.09689C10.5359 7.39563 9.58528 7.00125 8.59392 7L8.59407 7.00016ZM11.3341 11.0002H5.33405V10.7402C5.3353 10.0139 5.62468 9.31768 6.1378 8.80385C6.65155 8.29073 7.34781 8.00135 8.07413 8.0001H8.57414C9.30414 7.99635 10.0054 8.2826 10.5229 8.79699C11.0411 9.31136 11.333 10.0101 11.3342 10.7402L11.3341 11.0002Z",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("path", {
      d: "M12.834 0H3.304C2.47587 0 1.80399 0.671876 1.80399 1.50001V2.00001H0.833987C0.55773 2.00001 0.333984 2.22376 0.333984 2.50001C0.333984 2.77627 0.55773 3.00002 0.833987 3.00002H1.80399V5.50003H0.833987C0.55773 5.50003 0.333984 5.72378 0.333984 6.00003C0.333984 6.27629 0.55773 6.50004 0.833987 6.50004H1.80399V12.5001C1.80399 13.3282 2.47587 14.0001 3.304 14.0001H12.834C13.6621 14.0001 14.334 13.3282 14.334 12.5001V1.50001C14.334 0.671876 13.6621 0 12.834 0ZM13.334 12.5001C13.334 12.6326 13.2815 12.7601 13.1877 12.8538C13.094 12.9476 12.9665 13.0001 12.834 13.0001H3.30401C3.02775 13.0001 2.804 12.7763 2.804 12.5001V6.50003H3.33401C3.61027 6.50003 3.83401 6.27629 3.83401 6.00003C3.83401 5.72377 3.61027 5.50003 3.33401 5.50003H2.804V3.00001H3.33401C3.61027 3.00001 3.83401 2.77627 3.83401 2.50001C3.83401 2.22375 3.61027 2.00001 3.33401 2.00001H2.804V1.5C2.804 1.22374 3.02775 0.999999 3.30401 0.999999H12.834C12.9665 0.999999 13.094 1.0525 13.1877 1.14625C13.2815 1.24 13.334 1.3675 13.334 1.5V12.5001Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(ContactsBookIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
